<script>
import { h } from 'vue';

export default {
  props: {
    template: {
      type: String
    },
  },
  render(props) {
    return h("div", { innerHTML: props.template});
  }
};
</script>
